import { twMerge } from 'tailwind-merge';
import { BaseButton } from '@repo/common';
import { ReactComponent as BackpackIcon } from '@repo/common/assets/icons/32px/icon_32px_backpack_outline.svg';

const TASK_GRID_CARD_CLASS =
  'flex h-[148px] w-full flex-col items-center justify-center gap-2 rounded-[15px] border-2 p-6 text-center transition-colors duration-200';

function PathfinderMultiSelectCardGrid({
  options = [],
  value = [],
  onChange,
  exclusiveOptionCode,
  layoutVariant = 'default',
}) {
  const handleToggle = (id) => {
    let next;

    if (exclusiveOptionCode && id === exclusiveOptionCode) {
      next = value.includes(id) ? [] : [id];
    } else {
      const withoutExclusive = exclusiveOptionCode
        ? value.filter((selectedValue) => selectedValue !== exclusiveOptionCode)
        : [...value];

      next = withoutExclusive.includes(id)
        ? withoutExclusive.filter((selectedValue) => selectedValue !== id)
        : [...withoutExclusive, id];
    }

    onChange?.(next);
  };

  const isTaskGrid = layoutVariant === 'task-grid';

  return (
    <div className='grid w-full grid-cols-2 gap-4 justify-items-start'>
      {options.map((option) => {
        const selected = Array.isArray(value) && value.includes(option.id);

        return (
          <BaseButton
            key={option.id}
            type='text'
            size='m'
            htmlType='button'
            hideIcon
            typo={false}
            isStatic
            onClick={() => handleToggle(option.id)}
            textWrapperClass={twMerge(
              'flex h-full w-full',
              isTaskGrid
                ? 'flex-col items-center justify-center gap-2'
                : 'items-center gap-3'
            )}
            className={twMerge(
              'group h-auto min-w-0 cursor-pointer',
              isTaskGrid
                ? TASK_GRID_CARD_CLASS
                : 'flex min-h-[76px] w-full max-w-[426px] items-center gap-3 rounded-[15px] border-2 px-4 py-4 text-left transition-[background-color,border-color,box-shadow,opacity] duration-300 ease-out',
              selected
                ? 'border-surface-green40 bg-green-light01 shadow-[0_10px_30px_rgba(0,158,79,0.08)]'
                : 'border-transparent bg-surface-lightgray60 opacity-[0.94] hover:border-surface-green40 hover:bg-green-light01 hover:opacity-100 hover:shadow-[0_10px_30px_rgba(0,158,79,0.08)]'
            )}
          >
            <div
              className={twMerge(
                'flex h-12 w-12 shrink-0 items-center justify-center rounded-[8px] transition-colors duration-300 ease-out',
                selected ? 'bg-[rgba(0,158,79,0.10)]' : 'bg-[rgba(236,233,228,0.50)] group-hover:bg-[rgba(0,158,79,0.10)]'
              )}
            >
              <BackpackIcon
                className={twMerge(
                  'size-8 transition-colors duration-300 ease-out',
                  selected ? 'text-green-deep02' : 'text-text-placeholder group-hover:text-green-deep02'
                )}
              />
            </div>

            <div
              className={twMerge(
                'flex min-w-0 flex-col gap-[2px]',
                isTaskGrid ? 'items-center' : 'flex-1 items-start'
              )}
            >
              <span
                className={twMerge(
                  'text-base font-medium leading-[1.5] transition-colors duration-300 ease-out',
                  isTaskGrid ? 'text-center' : '',
                  selected
                    ? 'text-green-deep02'
                    : isTaskGrid
                    ? 'text-text-tertiary group-hover:text-green-deep02'
                    : 'text-text-secondary group-hover:text-green-deep02'
                )}
              >
                {option.title}
              </span>
              {option.caption && (
                <span
                  className={twMerge(
                    'text-[13px] font-normal leading-[1.4] transition-colors duration-300 ease-out',
                    isTaskGrid ? 'text-center' : '',
                    selected ? 'text-green-deep02' : 'text-text-placeholder group-hover:text-green-deep02'
                  )}
                >
                  {option.caption}
                </span>
              )}
            </div>
          </BaseButton>
        );
      })}

    </div>
  );
}

export default PathfinderMultiSelectCardGrid;
